export const skipAPIErrorCode = [
  "error_device_already_off_wall",
  "error_device_already_on_wall",
  "error_user_invalid_external_system_id",
];
